import React from 'react';
import { useModal } from '~shared/components/modal-overlay/ModalContext';
import { zIndexStart } from '~shared/components/modal-overlay/constants';

const Modals = () => {
    const { modals } = useModal();

    return (
        <>
            {Boolean(modals.length) && <div className='modal-background' style={{ zIndex: zIndexStart + modals.length }}/>}
            {modals}
        </>
    );
};

export default Modals;
